export const objectHistoryLogObjectTypes = [
    // 'BuyerOffer',
    'BuyerOptionGroup',
    'ChangeRequest',
    // 'ChangeRequestParticipant',
    'CommentThread',
    'Email',
    'ExternalAgreement',
    'Order',
    // 'PricingFieldValue',
    'Project',
    'ProjectDocument',
    'ResidentialUnit',
    'ResidentialUnitDocument',
    'Sms',
    'ProjectCatalogLinkGroup',
    'OptionPresetGroup',
    'OptionPreset',
    'Dependency',
] as const;

export type ObjectHistoryLogObjectType = typeof objectHistoryLogObjectTypes[number];